module.exports = __webpack_public_path__ + "img/down-circle.3f5aa7d0.svg";